import { DatePipe } from '@angular/common';
import { format as formatFn, isValid } from 'date-fns';
import { Country, Terminal } from './location';
import { Parcel } from './parcel';
import { Product } from './product';
import { Region } from './region';
import { safeParseDate } from './safe-parse-date';

export const sanitizeAndFormatDate = (date: Date | string | number) => {
  if (!date) {
    return '';
  }

  const sanitizedDate = sanitizeDate(date);
  if (!sanitizedDate) {
    return '';
  }
  return format(sanitizedDate, 'yyyy-MM-dd');
};

export const sanitizeDate = (dateString: Date | string | number) => {
  if (!dateString) {
    return null;
  }
  const date = safeParseDate(dateString);
  try {
    if (!isValid(date)) {
      return null;
    }
    return date;
  } catch {
    return null;
  }
};

const format = (date: Date | string, dateFormat: string) => {
  if (!date) {
    return null;
  }
  return formatFn(safeParseDate(date), dateFormat);
};

export const formatParcelValues = (
  parcels: Parcel[],
  products: Map<string, Product>,
  countries: Map<string, Country>,
  terminals: Map<string, Terminal>,
  regions: Map<string, Region>,
) => {
  const datePipe = new DatePipe('en-US');
  return parcels?.map((parcel) => ({
    ...parcel,
    productId: parcel.productId ? products.get(parcel.productId)?.name : '',
    sourceCountryId: parcel.sourceCountryId ? countries.get(parcel.sourceCountryId)?.name : '',
    destinationCountryId: parcel.destinationCountryId ? countries.get(parcel.destinationCountryId)?.name : '',
    destinationPortId: parcel.destinationPortId ? terminals.get(parcel.destinationPortId)?.name : '',
    originPortId: parcel.originPortId ? terminals.get(parcel.originPortId)?.name : '',
    destinationRegionId: parcel.destinationRegionId ? regions.get(parcel.destinationRegionId)?.name : '',
    sourceRegionId: parcel.sourceRegionId ? regions.get(parcel.sourceRegionId)?.name : '',
    buyersNames: parcel.buyers ? parcel.buyers.map((buyer) => buyer?.companyName).join(', ') : '',
    sellersNames: parcel.sellers ? parcel.sellers.map((seller) => seller?.companyName).join(', ') : '',
    blDate: datePipe.transform(parcel.blDate, 'MMM dd, yyyy'),
    dateDestination: datePipe.transform(parcel.dateDestination, 'MMM dd, yyyy'),
    updatedDateTime: datePipe.transform(parcel.updatedDateTime, 'MMM dd, yyyy'),
    laycanStart: datePipe.transform(parcel.laycanStart, 'MMM dd, yyyy'),
    laycanEnd: datePipe.transform(parcel.laycanEnd, 'MMM dd, yyyy'),
    buyers: [],
    sellers: [],
  }));
};
